import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import flashMessagePlugin from './flash-message';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlashMessage',
  props: {
  /* the id of the flash-message */
  id: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const flashMessage = computed(() => flashMessagePlugin.get(props.id));

const message = computed(() => flashMessage.value?.message);

const alertTypeCssClass = computed(() => {
  switch (flashMessage.value?.type) {
    case 'success':
      return 'alert-success';
    case 'warning':
      return 'alert-warning';
    case 'error':
      return 'alert-danger';
    default:
      return 'alert-info';
  }
});

return { __sfc: true,props, flashMessage, message, alertTypeCssClass }
}

})